import React from 'react'
import PropTypes from 'prop-types'

const Option = ({ text, value, selected, handleOnClick, index, total }) => {
  const id = `option_${value}_days`
  const classActive = selected ? 'bg-ui-4 border-color-brand-1 color-brand-1 bg-ui-4' : ' border-color-ui-2'
  return (
    <div
      className={`draggable-item  px-half ${
        total - 1 === index || total - 2 === index
          ? 'd-inline-block d-md-none d-lg-inline-block'
          : 'd-inline-block'
      }`}
    >
      <a
        id={`filter-${index}`}
        name={id}
        href='javascript:void(0)'
        role='button'
        className={`d-block radius  pointer border  py-1 px-1 txt-body-sm txt-left ${classActive}`}
        onClick={() => handleOnClick(value)}
        title='Filtrar extrato'
      >{selected ? <strong>{text}</strong> : <span>{text}</span>}</a>
    </div>
  )
}

Option.propTypes = {
  text: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  selected: PropTypes.string.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  index: PropTypes.integer,
  total: PropTypes.integer
}

const Filters = ({ options, onFilterSelect, filterSelected, currentTab }) => {
  return (
    <div className='row bg-white radius-top border-color-ui-3 border-bottom mx-0 px0 px-md-2'>
      <div className='col-12 px-0 px-md-half'>
        <div className='row mx-0 pt-1'>
          <div className='col-12 px-2 px-sm-1'>
            <p className='txt-subtitle'>Selecione um período</p>
          </div>
        </div>
        <div className='draggable px-3 px-md-0 pt-1 pb-2'>
          {options.map(({ text, value }, index) => {
            return currentTab.name === 'Expirations' ? (
              <Option
                text={text}
                value={value}
                selected={value === filterSelected && value === filterSelected}
                handleOnClick={onFilterSelect}
                index={index}
                total={options.length}
              />
            ) : (
              <Option
                text={text}
                value={value}
                selected={value.startDate === filterSelected.startDate && value.endDate === filterSelected.endDate}
                handleOnClick={onFilterSelect}
                index={index}
                total={options.length}
              />
            )
          }
          )}
        </div>
      </div>
    </div>
  )
}

Filters.propTypes = {
  onFilterSelect: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  filterSelected: PropTypes.string.isRequired,
  currentTab: PropTypes.object
}

export default Filters



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/Filters.js